import { type Widget } from '@parkingbase/ecommerce-api';
import { create } from 'zustand';
import { WidgetService } from '@/services/widget.service';
import { logger } from '@/lib/logger';


const widgetService = new WidgetService();

interface WidgetState {
  widget: Widget | null;
  isLoading: boolean;
  getDefaultWidget: () => Promise<void>;
}

export const useWidgetStore = create<WidgetState>((set) => ({
  widget: null,
  isLoading: false,
  getDefaultWidget: async () => {
    try {
      set({ isLoading: true });
      const widget = await widgetService.getDefaultWidget();
      set({ widget });
    } catch (error) {
      logger.error('Failed to fetch default widget', error, {
        feature: 'widget-store',
        route: 'getDefaultWidget',
      });
    } finally {
      set({ isLoading: false });
    }
  },
}));

/** Returns true if the widget has at least one non-empty position */
export function hasWidgetContent(widget: Widget | null | undefined): boolean {
  if (!widget?.widgetMap) return false;
  return Object.values(widget.widgetMap).some((html) => !!html?.trim());
}
